import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";
import { useTranslation } from "react-i18next";

const filterN1DataUploadSchema = z.object({
  file_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  provider_config_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});
const filterN1DataUpload = filterN1DataUploadSchema.keyof().enum;

export const ConfigSchema = z.object({
  id: z.number(),
  code: z.string(),
  file_pattern: z.string().optional(),
  client: z.string().optional(),
  mime_type: z.string().optional(),
  template_s3_key: z.string().optional(),
  usage_description: z.string().optional(),
});

export const UploadSchema = z.object({
  config_name: z.string().min(1, "La configuration est requise"),
  files: z
    .array(z.instanceof(File))
    .nonempty("Vous devez ajouter au moins un fichier"),
});

export type UploadSchemaType = z.infer<typeof UploadSchema>;
export type ConfigSchemaType = z.infer<typeof ConfigSchema>;

export type FilterN1DataUploadSchema = z.infer<typeof filterN1DataUploadSchema>;

export function N1DataUploadFilter() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: filterN1DataUpload.file_name_contains,
      label: t("n1_data_upload.searchbox.file_name_contains", { defaultValue: "File name" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.N1}/${ClientTables.N1_DATA_UPLOAD}`,
      column_name: "file_file_name",
    },
    {
      name: filterN1DataUpload.provider_config_name_contains,
      label: t("n1_data_upload.searchbox.provider_config_name_contains", { defaultValue: "Configuration name" }),
      type: "asyncAutocomplete",
      base_url: `${Clients.N1}/${ClientTables.N1_DATA_UPLOAD}`,
      column_name: "provider_config_name",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t("n1_data_upload.searchbox.created_at", { defaultValue: "Creation date" }),
      from: { name: filterN1DataUpload.created_at_from },
      to: { name: filterN1DataUpload.created_at_to },
      col_span: 2,
    },
  ];
  return (
    <FilterTable
      client={Clients.N1}
      schema={filterN1DataUploadSchema}
      tableName={ClientTables.N1_DATA_UPLOAD}
      fields={fields}
    />
  );
}
